import splitBlocks from './blocks/split'
import eventsBlocks from './blocks/events'
import secretariesBlocks from './blocks/secretaries'
import docs from './docs'

const blocks = {}
;[...splitBlocks, ...eventsBlocks, ...secretariesBlocks].forEach((block) => {
  blocks[block.id] = block
})

export function getBlock(id) {
  return blocks[id] || null
}

export function getDoc(id) {
  return docs[id] || null
}



// WEBPACK FOOTER //
// ./src/docs/index.js